import {
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import dayjs from 'dayjs';
import React, { memo } from 'react';

import TrashIcon from 'common/shared-ui/src/icons/TrashIcon';

import { useTranslation } from '../../../../../packages/common/utils/getLocalString';

// Original class: calendarExceptionRoot
const StyledCalendarExceptionRoot = styled(Table)(({ theme }) => ({
  maxWidth: 228,
  borderRadius: theme.spacing(4),
  border: '1px solid #E4E4EF',
  borderCollapse: 'unset !important',
  marginBottom: theme.spacing(4),
  height: 'fit-content',
  minHeight: 110,
  [theme.breakpoints.down('lg')]: {
    marginRight: theme.spacing(4),
  },
  [theme.breakpoints.down('sm')]: {
    maxWidth: 'unset',
  },
  [theme.breakpoints.down('xs')]: {
    marginRight: 0,
  },
}));
// Original class: tableRow
const StyledTableRow = styled(TableRow)(theme => ({
  height: 52,

  '& [class*=tableCell]:last-child': {
    borderRight: 0,
  },

  '& .MuiTableCell-sizeLarge': {
    borderRight: 0,
  },
}));
// Original class: tableCell
const StyledTableCell = styled(TableCell)(theme => ({
  borderRight: '1px solid #E4E4EF',
  width: 68,

  '&.MuiTableCell-sizeLarge': {
    width: 126,
  },

  '&.MuiTableCell-sizeSmall': {
    width: 36,
    padding: 0,
  },
}));
// Original class: exclusions
const StyledExclusions = styled(TableRow)(theme => ({
  '& .MuiTableCell-root': {
    borderBottom: 'unset',
  },

  '& .MuiTableCell-root:last-child': {
    borderRight: 'unset',
  },

  '& .MuiTableCell-root:first-of-type': {
    borderRight: '1px solid #E4E4EF',
  },
}));
const CalendarException = ({ exclusions, removeException }) => {
  const getLocalString = useTranslation();
  return (
    <StyledCalendarExceptionRoot>
      <TableHead>
        <StyledTableRow>
          <StyledTableCell align='left' size='medium'>
            <Typography
              variant='h4'
              sx={{
                fontWeight: 700,
              }}
            >
              {getLocalString('labels', 'hours')}
            </Typography>
          </StyledTableCell>
          <StyledTableCell align='left' size='large'>
            <Typography
              variant='h4'
              sx={{
                fontWeight: 700,
              }}
            >
              {getLocalString('labels', 'date')}
            </Typography>
          </StyledTableCell>
          <StyledTableCell align='left' size='small' />
        </StyledTableRow>
      </TableHead>
      <TableBody>
        {Object.entries(exclusions).map(([exclusion, exclusionObject]) => {
          return (
            <StyledExclusions key={exclusionObject.date}>
              <StyledTableCell align='center' size='medium'>
                {exclusionObject.hours}
              </StyledTableCell>
              <StyledTableCell align='left' size='large'>
                {dayjs(exclusionObject.date).format('DD.MM.YYYY')}
              </StyledTableCell>
              <StyledTableCell align='center' size='small'>
                <IconButton
                  disableRipple
                  onClick={removeException}
                  id={exclusionObject?.id?.toString()}
                  value={exclusionObject.date}
                >
                  <TrashIcon width='16' height='16' viewBox='0 0 16 16' />
                </IconButton>
              </StyledTableCell>
            </StyledExclusions>
          );
        })}
      </TableBody>
    </StyledCalendarExceptionRoot>
  );
};

export default memo(CalendarException);
